export default __webpack_public_path__ + "static/media/breakfast-club.7475e7c8.svg";